import { useState } from 'react';
import { searchClient } from '@app/api2/Clients';
import { PersonListDto, PersonSearchResponse } from '@app/api2/api';
import { SearchCriteriaParamsType } from './types';

export function useSearchExecutor() {
  const [isSearching, setIsSearching] = useState(false);

  const executeMultipleSearch = async (params: SearchCriteriaParamsType[]): Promise<PersonListDto[]> => {
    let searchResponse: PersonSearchResponse = { items: [] };

    searchResponse = await searchClient.searchByCriterias({ criterias: [ ...params] });

    const response = searchResponse;
    const data = response?.items;
    if (response) {
      return Array.isArray(data) ? data : [];
    } else {
      throw new Error('Search failed');
    }
  };

  return { isSearching, setIsSearching, executeMultipleSearch };
}